import { ICON__calculator_solid_full } from '@/assets/icons_fa';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';

interface PROPS {
  field: FIELD__base;
}

export function G_TABLE_CELL__inputs__field_kind({ field }: PROPS) {
  function render_icon_computed() {
    if (!field.meta.kind__is_output) return <span className="w-3 min-w-3" />;

    return <ICON__calculator_solid_full className="!size-3 min-w-3 min-h-3" />;
  }

  return (
    <span className="flex items-center gap-1">
      {render_icon_computed()}
      {field.meta.field_kind}
    </span>
  );
}
